module.exports = __webpack_public_path__ + "static/media/IMG_20191128_150350.c7beed8b.jpg";